import { DayOfWeekSelect } from '@schooly/style';
import { getControllerErrorText } from '@schooly/utils/get-controller-error-text';
import type { FC } from 'react';
import { Controller, get, useFormContext } from 'react-hook-form-lts';
import { useIntl } from 'react-intl';
import { $enum } from 'ts-enum-util';

export enum WeekDays {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}

export const DAY_OF_WEEK_OPTIONS = $enum(WeekDays).map((value, key) => ({
  labelTextId: `week-${key}`,
  value,
}));

type FormDayOfWeekSelectProps = {
  name: string;
  required: boolean;
};

export const FormDayOfWeekSelect: FC<FormDayOfWeekSelectProps> = ({ name, required }) => {
  const { control, setValue, formState, trigger } = useFormContext<Record<string, number[]>>();

  const { $t } = useIntl();

  const error = get(formState.errors, name);
  const errorMessage = getControllerErrorText(error, undefined, $t);

  const dayOptions = DAY_OF_WEEK_OPTIONS.map(({ labelTextId, value }) => ({
    value,
    label: $t({ id: labelTextId }).at(0) || '',
  }));

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required,
      }}
      render={({ field }) => {
        return (
          <DayOfWeekSelect
            selectedDays={field.value}
            options={dayOptions}
            errorMessage={errorMessage}
            onChange={(selectedDays: WeekDays[]) => {
              setValue(name, selectedDays);
              if (error) trigger(name);
            }}
          />
        );
      }}
    />
  );
};
